<div class="install">
  <h1>Instalar o NCommerce</h1>

  @if (!install) {
    <p>Digite o código de instalação que a equipe NCommerce enviou para você.</p>
    <form (ngSubmit)="lookup()">
      <input
        class="form-control code-input"
        name="code"
        [(ngModel)]="code"
        maxlength="9"
        autocomplete="off"
        autocapitalize="characters"
        spellcheck="false"
        placeholder="EX.: K7M2-QX9P"
        [disabled]="loading">
      <button class="btn btn-primary" type="submit" [disabled]="loading || normalizedCode().length !== codeLength">
        {{ loading ? 'Verificando...' : 'Continuar' }}
      </button>
    </form>
    @if (error) {
      <p class="error">{{ error }}</p>
    }
  } @else {
    <p>Instalação para <strong>{{ install.company }}</strong>.</p>
    <p class="hint">O código vale até {{ install.expires_at | date:'dd/MM HH:mm' }} e só pode ser usado em um computador.</p>
    @if (install.redeemed) {
      <p class="warning">Este código já foi usado. Só o mesmo computador consegue usá-lo de novo.</p>
    }

    <a class="btn btn-success download" [href]="downloadUrl()">Baixar o instalador</a>

    <app-install-steps></app-install-steps>

    <button class="btn btn-link" type="button" (click)="reset()">Usar outro código</button>
  }
</div>
